import conn from "@/store/utils/connection";
import snapConsoleAPI from "@/store/utils/api-route/snapConsoleAPI";
import resulter from "@/store/utils/resulter";
import state from "./state";

const actions = {
    async fetchListSnapConsole({commit, rootGetters}, idoutlet) {
        try {
            let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

            let query = {
                idoutlet: idoutlet,
                offset: state.pagination.offset,
                limit: state.pagination.limit,
                jenis: getFilterItem.jenisSnapConsole
            }

            const res = await conn.get(snapConsoleAPI.list, query)
            if (!res.data){
                throw(res)
            }
            if (res.data.status){
                await conn.setQueryString(query)
                commit("setListSnapConsole", res.data)
                return resulter.successResult()
            }

        } catch (e) {
            return resulter.errorResult(e)
        }
    },

    async changePinConsole({commit}, payload){
        try {
            let query = {
                idconsole: payload.idconsole,
                idoutlet: payload.idoutlet
            }
            let form = new FormData()
            form.append("pin", payload.pin)
            const res = await conn.post(snapConsoleAPI.updatePin, form, conn.contentType.form, query)
            if (!res.data){
                throw(res)
            }
            if (res.data.code === 200) {
                return resulter.successResult(res.data.msg)
            } else {
                return resulter.errorResult(res.data.msg)
            }
        } catch (e) {
            return resulter.errorResult(e)
        }
    }
}

export default actions